
export function dispatchCustomEvent(eventKey, data=[]) {
    const event = new CustomEvent(eventKey, {
        detail: { eventKey: eventKey, data: data },
        bubbles: true,
        cancelable: true,
    });
    window.dispatchEvent(event)
}

export function listener(id, handleFunction, ref=null) {
    if (ref) {
        ref.current.addEventListener(id, handleFunction)
        return () => {
            ref.current.removeEventListener(id, handleFunction)
        }
    }else {
        window.addEventListener(id, handleFunction)
        return () => {
            window.removeEventListener(id, handleFunction)
        }
    }
}
